export const ORDER_STATUSES = Object.freeze({
  0: { text: '待审核', tone: 'pending' },
  1: { text: '待拍单', tone: 'active' },
  2: { text: '已拍单', tone: 'success' },
  91: { text: '已取消', tone: 'neutral' },
  92: { text: '订单未找到', tone: 'error' },
  99: { text: '失败', tone: 'error' },
});
export const AMAZON_STATUSES = Object.freeze({
  0: { text: '待同步', tone: 'pending' },
  1: { text: '已签收', tone: 'success' },
  2: { text: '运输中', tone: 'active' },
  3: { text: '未发货', tone: 'neutral' },
  99: { text: '已取消', tone: 'neutral' },
});
export const getLogisticsStatus = (order) => {
  const status = AMAZON_STATUSES[order.amzStatus] || {
    text: order.amzStatus == null ? '暂无物流' : '未知状态',
    tone: 'neutral',
  };
  return { ...status, text: order.amzStatusDesc || status.text };
};
export const formatUsd = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  const amount = Number(String(value).replace(/[$,]/g, ''));
  return Number.isFinite(amount)
    ? '$' +
        amount.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
    : String(value);
};
export const canResetOrder = (order) =>
  order.status === 99 && (order.amzStatus === 0 || order.amzStatus == null);
